import React, { useState, useEffect } from 'react';
import './MassSpyPopup.css';

// Collection of random spy activity texts
const spyActivities = [
  "Extracting contact data...",
  "Analyzing source code...",
  "Searching meta tags...",
  "Scanning for email addresses...",
  "Checking social media links...",
  "Extracting business information...",
  "Analyzing company description...",
  "Collecting Instagram posts...",
  "Searching hidden APIs...",
  "Looking for team members...",
  "Finding contact forms...",
  "Checking plugin data...",
  "Analyzing metadata...",
  "Decoding tracking codes...",
  "Capturing location information...",
  "Collecting business hours...",
  "Scanning for phone numbers...",
  "Checking hosting information...",
  "Analyzing website structure...",
  "Checking WHOIS data...",
  "Finding hidden links...",
  "Extracting company history...",
  "Analyzing website age...",
  "Searching for price lists...",
  "Collecting product information...",
  "Checking SSL certificates...",
  "Scanning for payment methods...",
  "Identifying website technologies...",
  "Collecting customer reviews...",
  "Extracting web fonts and brand elements..."
];

const MassSpyPopup = ({
  isMassSpyActive,
  massSpyProgress,
  massSpyTotal,
  massSpyQueue,
  massSpyResults,
  closeMassSpy,
  onDeleteNoEmailEntries
}) => {
  const [currentActivity, setCurrentActivity] = useState(spyActivities[0]);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  
  // Changes to a new random activity every 3 seconds
  useEffect(() => {
    if (!isMassSpyActive || isCompleted) return;
    
    const intervalId = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * spyActivities.length);
      setCurrentActivity(spyActivities[randomIndex]);
    }, 3000);
    
    return () => clearInterval(intervalId);
  }, [isMassSpyActive, isCompleted]);
  
  // Checks if the analysis is completed
  useEffect(() => {
    if (massSpyProgress === massSpyTotal && massSpyTotal > 0 && massSpyResults) {
      setIsCompleted(true);
    } else {
      setIsCompleted(false);
    }
  }, [massSpyProgress, massSpyTotal, massSpyResults]);
  
  // Neue Funktion für Löschung
  const handleDeleteNoEmailEntries = () => {
    setIsDeleting(true);
    onDeleteNoEmailEntries().finally(() => {
      setIsDeleting(false);
      closeMassSpy();
    });
  };
  
  if (!isMassSpyActive) return null;

  // Calculate progress percentage
  const progressPercent = Math.round((massSpyProgress / massSpyTotal) * 100);
  
  // Current contact being analyzed
  const currentTarget = massSpyQueue[0]?.business_name || massSpyQueue[0]?.lead_website || "...";

  // Berechnen wie viele Einträge keine E-Mail haben
  const entriesWithoutEmail = massSpyTotal - massSpyResults.emailsFound;
  const hasEntriesWithoutEmail = entriesWithoutEmail > 0;

  return (
    <div className="popupOverlayWrapper">
      <div className="popupOverlayBackground"></div>
      <div className="spypopupContentWrapper mass-spy-popup">
        <div className="mass-spy-popup-content">
          <div className="spy-header">
            <h2>BonusClub Website Spy</h2>
          </div>
          
          {/* Spinner and icon only shown when not completed */}
          {!isCompleted && (
            <div className="spy-icon-container">
              <div className="spy-spinner-circle">
                <img src="/img/binoculars.svg" alt="Spy" className="spy-icon-large" />
                <div className="spy-spinner-ring"></div>
              </div>
            </div>
          )}
          
          {/* Target info only shown when not completed */}
          {!isCompleted && (
            <div className="spy-target-info">
              <div className="spy-current-target">
                <span className="spy-label">TARGET:</span> 
                <span className="spy-value">{currentTarget}</span>
              </div>
              <div className="spy-status">
                <span className="spy-activity-indicator">⚡</span> {currentActivity}
              </div>
            </div>
          )}
          
          <div className="mass-spy-progress-container">
            <div className="mass-spy-progress-bar">
              <div 
                className="mass-spy-progress-fill" 
                style={{width: `${progressPercent}%`}}
              ></div>
            </div>
            <div className="mass-spy-progress-text">
              <span className="spy-progress-count">{massSpyProgress} of {massSpyTotal}</span>
              <span className="spy-progress-percent">{progressPercent}%</span>
            </div>
          </div>
          
          {isCompleted && (
            <div className="mass-spy-results">
              <h3>Mission Completed</h3>
              
              <div className="mass-spy-stats">
                <div className="mass-spy-stat">
                  <div className="mass-spy-stat-value">{massSpyResults.emailsFound}</div>
                  <div className="mass-spy-stat-label">Email Addresses</div>
                </div>
                <div className="mass-spy-stat">
                  <div className="mass-spy-stat-value">{massSpyResults.descriptionsFound}</div>
                  <div className="mass-spy-stat-label">Descriptions</div>
                </div>
                <div className="mass-spy-stat">
                  <div className="mass-spy-stat-value">{massSpyResults.successCount}</div>
                  <div className="mass-spy-stat-label">Successful Scans</div>
                </div>
                <div className="mass-spy-stat">
                  <div className="mass-spy-stat-value">{massSpyResults.errorCount}</div>
                  <div className="mass-spy-stat-label">Errors</div>
                </div>
                {massSpyResults.skippedCount > 0 && (
                  <div className="mass-spy-stat">
                    <div className="mass-spy-stat-value">{massSpyResults.skippedCount}</div>
                    <div className="mass-spy-stat-label">Skipped</div>
                  </div>
                )}
              </div>
              
              <div className="mass-spy-actions">
                {hasEntriesWithoutEmail && (
                  <button 
                    className="mass-spy-delete-btn" 
                    onClick={handleDeleteNoEmailEntries}
                    disabled={isDeleting}
                  >
                    {isDeleting ? 'Deleting...' : `Delete ${entriesWithoutEmail} Entries Without Email`}
                  </button>
                )}
                <button className="mass-spy-close-btn" onClick={closeMassSpy}>
                  {hasEntriesWithoutEmail ? 'Keep & Close' : 'Close'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MassSpyPopup; 